module.exports = new __parcel__URL__("wind-rt.73f52874.png").toString();